import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import _ from 'lodash';
import { ETATS_FACTURE } from '@/constants';
import type { FactureListePrelevementItemType } from '@/types/facture';
import { formatMonetaire } from '@/utils';

interface RejetsListeTableRowProps {
  item: FactureListePrelevementItemType;
  rowProps: Record<string, unknown>;
}

const RejetsListeTableRow = (props: RejetsListeTableRowProps) => {
  const { item, rowProps } = props;

  const {
    identifiant,
    numero,
    dateEmission,
    montant,
    cycle,
    etatFacture,
    titulaireComptePreleve,
    compteBancairePreleve,
    dateRejet,
    motifRejet,
  } = item;

  // Un rejet ne peut plus être supprimé si la facture est déjà encaissée.
  // Le marqueur ci-dessous permet de désactiver la croix de suppression via CSS (:has).
  // NB : l'infobulle associée (PrelevementsListe.less) est formulée côté cycle
  // (« Le cycle associé a été encaissé ») alors que le critère porte sur la facture.
  const rejetNonSupprimable = etatFacture === ETATS_FACTURE.ENCAISSEE;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="numero"
        // @ts-expect-error
        title={numero}
        style={{ height: 60 }}
        verticalAlign="middle"
      >
        {rejetNonSupprimable && <span className="rejet-non-supprimable" hidden aria-hidden />}
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {numero}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell name="montant" textAlign="right" verticalAlign="middle">
        {formatMonetaire(montant)}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="cycle"
        // @ts-expect-error
        title={`${cycle}${!_.isNil(dateEmission) && ` - ${dayjs(dateEmission).format('DD/MM/YYYY')}`}`}
        style={{ position: 'relative' }}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {cycle}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="titulaireComptePreleve"
        // @ts-expect-error
        title={titulaireComptePreleve}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {titulaireComptePreleve}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="compteBancairePreleve"
        // @ts-expect-error
        title={compteBancairePreleve}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {compteBancairePreleve}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell name="dateRejet" textAlign="left" verticalAlign="middle">
        {!_.isNil(dateRejet) && dayjs(dateRejet).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="motifRejet"
        verticalAlign="middle"
        // @ts-expect-error
        title={motifRejet}
      >
        {motifRejet}
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default RejetsListeTableRow;
